<template>
  <div class="news-classify">
    <div class="cl-title">
      <el-image :src="require('@/assets/news/icon.png')"></el-image>
      <span>新闻分类</span>
    </div>
    <div class="cl-title" :class="classifyId == v.classifyId?'act':''" v-for="(v,i) in classifyList"
         :key="i" @click="classifyFun(v)">
      <span>{{ v.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsClassify",
  props: {
    classifyId: [String, Number]
  },
  data() {
    return {
      classifyList: [
        {
          name: '行业新闻',
          classifyId: 1
        },
        {
          name: '城市新闻',
          classifyId: 2
        },
        {
          name: '通知公告',
          classifyId: 3
        },
        {
          name: '最新活动',
          classifyId: 4
        }
      ]
    }
  },
  methods: {
    /**
     * 分类选择
     * @param classifyId
     */
    classifyFun({classifyId}) {
      if (this.$route.path == '/news/detail') {
        this.$router.push(`/news?classifyId=${classifyId}`)
      } else {
        this.$emit('update:classifyId', classifyId)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-classify {
  width: 240px;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  background-color: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;

  .cl-title {
    height: 55px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #D7D7D7;
    cursor: pointer;

    &.act span {
      color: #1464FF;
    }

    span {
      color: #2D2D2D;
      font-size: 16px;
      font-weight: bold;
    }

    &:first-child {
      background-color: #1464FF;
      cursor: unset;

      span {
        color: #FFFFFF;
      }

      .el-image {
        width: 24px;
        height: 24px;
        margin-right: 2px;
      }
    }

    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>